{
  "$id": "module://grant-management",
  "$schema": "wealthlane://schemas/domain",
  "title": "Grant Management",
  "description": "Grant Management field catalog — maps to AddUpdateGrantDto",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "Grant ID",
      "widget": "hidden"
    },
    "planName": {
      "$ref": "module://plan-management#properties/name"
    },
    "uniquePlanNo": {
      "$ref": "module://plan-management#properties/uniquePlanNo"
    },
    "grantName": {
      "type": "string",
      "title": "Grant Name",
      "widget": "text",
      "required": true,
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "planId": {
      "type": "string",
      "title": "Plan Name",
      "widget": "select"
    },
    "planTypeName": {
      "type": "string",
      "title": "Grant Type",
      "widget": "select"
    },
    "planType": {
      "type": "string",
      "title": "Plan Type Label",
      "widget": "hidden"
    },
    "approvedDate": {
      "type": "string",
      "title": "Grant Date",
      "widget": "date",
      "format": "date"
    },
    "approvalRequired": {
      "type": "boolean",
      "title": "Require Acceptance",
      "widget": "checkbox",
      "default": false
    },
    "poolId": {
      "$ref": "module://share-pool#/$defs/poolId"
    },
    "acceptanceMethodId": {
      "type": "number",
      "title": "Acceptance Method",
      "widget": "select"
    },
    "acceptanceMethod": {
      "type": "string",
      "title": "Acceptance Method Label",
      "widget": "hidden"
    },
    "settlementTypeId": {
      "type": "string",
      "title": "Settlement Type",
      "widget": "select"
    },
    "settlementTypeName": {
      "type": "string",
      "title": "Settlement Type Label",
      "widget": "hidden"
    },
    "performanceRuleName": {
      "type": "string",
      "title": "Performance Rule",
      "widget": "select"
    },
    "performanceRuleId": {
      "type": "string",
      "title": "Performance Rule ID",
      "widget": "hidden"
    },
    "vestingTemplateName": {
      "type": "string",
      "title": "Vesting Template",
      "widget": "select"
    },
    "grantAcceptanceTemplateId": {
      "type": "string",
      "title": "Grant Acceptance Template",
      "widget": "select"
    },
    "grantAgreementDocumentName": {
      "type": "string",
      "title": "Grant Agreement Document",
      "widget": "select"
    },
    "grantNoticeDocumentName": {
      "type": "string",
      "title": "Grant Notice Document",
      "widget": "select"
    },
    "agreementStatement": {
      "type": "string",
      "title": "Agreement Statement",
      "widget": "text",
      "required": true,
      "noBlank": true
    },
    "agreementStatementStatusName": {
      "type": "string",
      "title": "Status",
      "widget": "select",
      "required": true,
      "options": [
        { "label": "Active", "value": "Active" },
        { "label": "InActive", "value": "InActive" }
      ]
    },
    "enableTermsConditionText": {
      "type": "boolean",
      "title": "Enable Terms & Condition Text",
      "widget": "toggle",
      "default": false
    },
    "termsAndConditionDocumentName": {
      "type": "string",
      "title": "Terms and Condition Document",
      "widget": "select"
    },
    "termsAndConditionTextName": {
      "type": "string",
      "title": "Terms and Condition Text",
      "widget": "select"
    },
    "isGrantInUse": {
      "type": "boolean",
      "title": "Grant In Use",
      "widget": "hidden",
      "default": false
    },
    "poolDisplayLabel": {
      "type": "string",
      "title": "Share Pool Display Label",
      "widget": "hidden"
    },
    "_originalApprovalRequired": {
      "type": "boolean",
      "title": "Original Approval Required",
      "widget": "hidden"
    },
    "planGrantDocuments": {
      "type": "array",
      "title": "Plan Grant Documents",
      "widget": "hidden",
      "default": []
    },
    "OPEN_VESTING_MODAL": {
      "type": "action-button",
      "label": "Add Vesting Template",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_PERFORMANCE_RULES_MODAL": {
      "type": "action-button",
      "label": "Add performance rule",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "VIEW_GRANT_PERFORMANCE_RULE": {
      "type": "action-button",
      "label": "View rule",
      "variant": "link"
    },
    "OPEN_GRANT_ACCEPTANCE_TEMPLATE_MODAL": {
      "type": "action-button",
      "label": "Add Grant Acceptance Template",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_GRANT_AGREEMENT_MODAL": {
      "type": "action-button",
      "label": "Add Grant Agreement",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_GRANT_NOTICE_MODAL": {
      "type": "action-button",
      "label": "Add Grant Notice",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_TERMS_CONDITIONS_DOC_MODAL": {
      "type": "action-button",
      "label": "Add Terms and Conditions Document",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_TERMS_CONDITIONS_TEXT_MODAL": {
      "type": "action-button",
      "label": "Add Terms and Conditions Text",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "grantAgreementDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    },
    "grantNoticeDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    },
    "termsConditionDocDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    },
    "termsConditionTextDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    }
  }
}
